import { h, Component, createRef } from 'preact'
import tdlib, { TdEvent } from '../../utils/tdlib'
import { iMessage } from '../../types/chat'
import Message from '../Message'
import s from './Dialog.css'

interface iProps {
  chatId: number,
  lastMessage: iMessage,
}

interface iState {
  messages: iMessage[]
}

class Dialog extends Component<iProps, iState> {
  ref = createRef<HTMLDivElement>()

  state = {
    messages: []
  }

  componentDidMount (): void {
    this.getChatHistory()
  }

  componentDidUpdate ({ chatId, lastMessage }: iProps): void {
    if (
      chatId !== this.props.chatId ||
      lastMessage.id !== this.props.lastMessage.id
    ) {
      this.getChatHistory()
    }
  }

  getChatHistory = async () => {
    const { lastMessage, chatId } = this.props

    await tdlib
      .send({
        '@type': 'getChatHistory',
        chat_id: chatId,
        from_message_id: lastMessage.id,
        offset: 0,
        limit: 30
      })
      .then(({ messages }: TdEvent) => {
        this.setState({
          messages: messages.reverse()
        }, this.scrollToBottom)
      })
  }

  scrollToBottom = () => {
    const { current: wrap } = this.ref

    wrap && wrap.scrollTo({
      top: wrap.scrollHeight,
      left: 0
    })
  }

  render () {
    const { chatId, lastMessage } = this.props
    const { messages }: iState = this.state

    return (
      <div
        className={s.Dialog}
        ref={this.ref}
      >
        {messages.map(message => (
          <Message
            key={message.id}
            chatId={chatId}
            message={message}
          />
        ))}

        <Message
          chatId={chatId}
          message={lastMessage}
        />
      </div>
    )
  }
}

export default Dialog
